import { getTheme } from '@fluentui/react';

const { palette } = getTheme();

export const getBaseStepLayoutStyles = () => ({
  stepContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  stepContentContainer: {
    overflowY: 'hidden',
    display: 'table-column',
    height: '100%',
    backgroundColor: palette.neutralLighterAlt,
  },

  mainSide: {
    width: '100%',
    height: '100%',
    paddingLeft: '32px',
    display: 'table-cell',
  },
});
